// GENERATED FILE, PLEASE DO NOT EDIT
var ButtonToggle = 'Pill';
var ButtonToggleGroup = 'Rectangle';
var ButtonDefault = 'Rectangle';
var PaginationNumbered = 'Circle';
var TagDefault = 'Pill';
var ShapeSemanticsAll = {
  ButtonDefault: ButtonDefault,
  ButtonToggle: ButtonToggle,
  ButtonToggleGroup: ButtonToggleGroup,
  PaginationNumbered: PaginationNumbered,
  TagDefault: TagDefault
};

export { ButtonDefault, ButtonToggle, ButtonToggleGroup, PaginationNumbered, ShapeSemanticsAll, TagDefault, ShapeSemanticsAll as default };
